import Image from 'next/image'
import { buildSanityImage } from '../../../../modules/utils'

const BlogDetailMobileMainImageSection = ({ post }) => {
  return (
    <div className="aspect-w-16 aspect-h-9 relative mb-[60px]">
      <Image
        alt={post.mainImage.alt}
        src={buildSanityImage(post.mainImage).url()}
        layout="fill"
        objectFit="cover"
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
        style={{ borderRadius: `${post.mainImage.imageRadius || 0}px` }}
        className="mx-auto"
      />
    </div>
  )
}

export default BlogDetailMobileMainImageSection

const style = {
  imageSectionLayout: `mb-[60px]`,
}
